import * as angular from 'angular';
import {AgentsAlerts} from "../../agents/services/agents-alerts.service";
import {BringozLoaderService} from "../../commons/services/bringoz-loader.service";
import {ItinerariesRequestsService} from "./itineraries-requests.service";

export class ItinerariesService {

  constructor(private itinerariesRequestsService: ItinerariesRequestsService, private agentRequests, private agentsAlerts: AgentsAlerts,
              private bringozLoaderService: BringozLoaderService, private $log) {

  }

  getItineraries(agentIds, extraAgentIds?) {
    const allAgentsIds = extraAgentIds && extraAgentIds.length ? extraAgentIds.concat(agentIds) : agentIds;
    this.bringozLoaderService.on();
    return this.itinerariesRequestsService.getItineraries(allAgentsIds)
      .catch((error) => {
        this.$log.error(error);
      })
      .finally(() => {
        this.bringozLoaderService.off();
      });
  }

  getPageableItineraries(params) {
    this.bringozLoaderService.on();
    return this.itinerariesRequestsService.getPageableItineraries(params)
      .catch((error) => {
        this.$log.error(error);
      })
      .finally(() => {
        this.bringozLoaderService.off();
      });
  }

  getInActiveTasks(agentId, date) {
    this.bringozLoaderService.on();
    return this.agentRequests.getAgentCompletedTaskByDate(agentId, date)
      .catch((error) => {
        this.$log.error(error);
      })
      .finally(() => {
        this.bringozLoaderService.off();
      });
  }

}

angular
  .module('bringoz.admin.itineraries')
  .service('itinerariesService', ItinerariesService);

